import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';
import { isSuperAdminClaims } from '../session';
import PulseLogo from '../components/PulseLogo';
import PulseItGroupFooter from '../components/PulseItGroupFooter';

function SuperAdminLogin() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            const cred = await signInWithEmailAndPassword(auth, email, password);
            const token = await cred.user.getIdTokenResult(true);
            if (!isSuperAdminClaims(token.claims)) {
                setError('This portal is for Pulse super admins only. Company staff use the company login.');
                setLoading(false);
                return;
            }
            navigate('/super-admin');
        } catch (err) {
            setError(err.message);
            setLoading(false);
        }
    };

    return (
        <div className="container-fluid min-vh-100 d-flex flex-column" style={{ background: '#0F172A' }}>
            <div className="flex-grow-1 d-flex align-items-center">
            <div className="row justify-content-center w-100">
                <div className="col-md-4">
                    <div className="card shadow-lg border-0">
                        <div className="card-body p-5">
                            <div className="text-center mb-4"><PulseLogo size="medium" showTagline={true} /></div>
                            <h5 className="text-center mb-1">Pulse Super Admin</h5>
                            <p className="text-center text-muted small mb-4">Dedicated portal · <code>/super-admin/login</code><br />Company staff use <code>/login</code></p>
                            {error && <div className="alert alert-danger">{error}</div>}
                            <form onSubmit={handleLogin}>
                                <input type="email" className="form-control mb-3" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                                <input type="password" className="form-control mb-3" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                                <button className="btn btn-dark w-100" disabled={loading}>{loading ? 'Verifying...' : 'Sign in'}</button>
                            </form>
                            <div className="text-center mt-3">
                                <Link to="/login" className="small">Company staff login</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
            <PulseItGroupFooter variant="dark" />
        </div>
    );
}

export default SuperAdminLogin;
